<template>
  <div class="partners-wrapper">
    <div class="partners">
      <div class="partners-presenters">
        <div class="partners__header">Presented by</div>
        <div class="partners__content">
          <a
            class="partners__link"
            target="_blank"
            href="https://www.goldmansachs.com/"
          >
            <v-responsive
              :aspect-ratio="1"
              alt="Goldman Sachs"
              class="sachs-logo"
            />
          </a>
        </div>
      </div>
      <div class="partners-sponsors">
        <div class="partners__header">Sponsored by</div>
        <div class="partners__content">
          <div
            class="sponsor"
            v-for="(sponsor, index2) in sponsors"
            :key="index2"
            :style="{ backgroundImage: `url(${sponsor.logo})` }"
          >
            <component
              :is="sponsor.url ? 'a' : 'div'"
              class="sponsor__link"
              target="_blank"
              :href="sponsor.url"
            >
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const getImage = name => require(`@/assets/sponsors/${name}.png`);
    return {
      sponsors: [
        {
          url: "https://thewaltdisneycompany.com/",
          logo: getImage("wd")
        },
        {
          url: "https://www.disneyplus.com/",
          logo: getImage("d+")
        },
        {
          url: "https://na.panasonic.com/us",
          logo: getImage("lumix")
        },
        {
          url: "https://elffound.org/",
          logo: getImage("elfenworks")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.partners {
  font-size: 36px;
  font-weight: 300;
  line-height: 1.2;
}
.sachs-logo {
  width: 183px;
  max-width: 95%;
  background-image: url("~@/assets/sachsLogo.png");
  background-size: contain;
  background-repeat: none;
}

.partners {
  display: flex;
  align-items: stretch;
  border-bottom: 2px solid $primary;
  &:first-child {
    border-top: 2px solid $primary;
  }
  @media screen and (max-width: 960px) {
    font-size: 28px;
    flex-direction: column;
  }

  &__header {
    @media screen and (max-width: 960px) {
      padding: 30px 20px;
    }
  }
  &__content {
    background: white;
    border-top: 2px solid $primary;
    flex-grow: 1;
    display: flex;
  }
  > div {
    display: flex;
    flex-direction: column;
  }
  > div:first-child {
    .partners__header,
    .partners__content {
      padding: 30px 30px 30px 120px;
      white-space: nowrap;
    }
    @media screen and (max-width: 1264px) {
      .partners__header,
      .partners__content {
        padding: 30px 30px 30px 56px;
      }
    }
    @media screen and (min-width: 961px) {
      min-width: 300px;
      flex-basis: 28%;
      border-right: 2px solid $primary;
    }
    @media screen and (max-width: 960px) {
      border-bottom: 2px solid $primary;
      .partners__header,
      .partners__content {
        padding: 30px 20px;
      }
    }
  }

  > div:last-child {
    .partners__header,
    .partners__content {
      justify-content: space-between;
      padding: 30px 120px 30px 30px;
      > * {
        flex-basis: 17%;
      }
    }
    @media screen and (max-width: 1264px) {
      .partners__header,
      .partners__content {
        padding: 30px 56px 30px 30px;
      }
    }
    @media screen and (min-width: 961px) {
      flex-basis: 72%;
    }
    @media screen and (max-width: 960px) {
      .partners__header,
      .partners__content {
        padding: 30px 20px;
        flex-wrap: wrap;
        > * {
          flex-basis: 40%;
        }
      }
    }
  }
}

.sponsor {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  min-height: 82px;
  > a {
    display: block;
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 960px) {
  .partners {
    &__header {
      background: white;
    }
    &__content {
      padding: 30px 20px;
      justify-content: center;
    }
  }
}
</style>
